import {submitEvent, submitMerge} from "@otto-ec/tracking-bct";

export default class TrackingService {

    emitClickTrackingPayload(follow: boolean, dreson: string) {
        const click_follow = follow ? "click_follow" : "click_unfollow";
        submitEvent({
            "promo_FollowBrandButton": [click_follow],
            "promo_FollowBrandButtonPSR": [dreson]
        })
    }

    emitLoadedTracking(follow: boolean, dreson: string, followCount: number) {
        const loaded_follow = follow ? "followed" : "not_followed";
        submitMerge({
            "promo_FollowBrandButton": [loaded_follow],
            "promo_FollowBrandButtonPSR": [dreson],
            "promo_BrandFollowCount": [followCount.toString()]
        })
    }

    emitLoadedEventTracking(follow: boolean, dreson: string, followCount: number) {
        const loaded_follow = follow ? "followed" : "not_followed";
        submitEvent(
            {
                "promo_FollowBrandButton": [loaded_follow],
                "promo_FollowBrandButtonPSR": [dreson],
                "promo_BrandFollowCount": [followCount.toString()]
            }
        )
    }

}
